export const BUY_URL =
  "https://learn.civilitypartners.com/course/train-the-trainer-toolkit";

export const IMAGES = {
  hero: "/catherine-facilitating.webp",
  slides: "/toolkit/training-slides.jpg",
  meeting:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjB0ZWFtJTIwbWVldGluZ3xlbnwwfHx8fDE3OTAxOTc2Nzl8MA&ixlib=rb-4.1.0&q=85",
  collaboration: "/toolkit/hr-collaboration.jpg",
  workshop:
    "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  founder: "/catherine-mattice.webp",
};
